import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnListDefinition } from 'src/app/controls/advanced-gridview/models/column-list-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { ListItem } from 'src/app/controls/filters/models/list-item';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Rights } from 'src/app/models/enums/rights';
import { Params } from 'src/app/models/params';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ParamsService } from 'src/app/services/params.service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-parameters-list',
    templateUrl: './parameters-list.component.html',
    styleUrls: ['./parameters-list.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class ParametersListComponent extends DefaultListComponent<Params> implements OnInit {
    typeColumnValues: ListItem<string>[] = [
        { value: 'Text', text: 'Texte' },
        { value: 'Number', text: 'Nombre' },
        { value: 'Date', text: 'Date' },
        { value: 'Boolean', text: 'Booléen' },
    ];

    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     * @param paramsService : Service de gestion des paramètres.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        public enumHelper: EnumHelper,
        private paramsService: ParamsService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        // Specifie des colonnes en fonction des droits utilisateurs
        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 5, true),
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 30, true),
                new ColumnListDefinition('type', 'Type', FilterType.List, 3, 20, true, true, this.typeColumnValues),
                new ColumnDefinition('groupName', 'Nom du groupe', ColumnType.Text, FilterType.Text, 4, 20, true),
                new ColumnDefinition('defaultValue', 'Valeur par défaut', ColumnType.Text, FilterType.Text, 5, 20, true),
            ];
        } else {
            this.tableConfig = [
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 40, true),
                new ColumnListDefinition('type', 'Type', FilterType.List, 3, 15, true, true, this.typeColumnValues),
                new ColumnDefinition('groupName', 'Nom du groupe', ColumnType.Text, FilterType.Text, 4, 20, true),
                new ColumnDefinition('defaultValue', 'Valeur par défaut', ColumnType.Text, FilterType.Text, 5, 20, true),
            ];
        }

        // Force le type à texte car par défaut le type est à liste.
        //this.tableConfig.find(x => x.columnName === "type").type = ColumnType.Text;

        // Spécifie les éléments du menu contextuel en fonction des droits utilisateur
        this.AddMenuItem('Dupliquer', MenuITemAction.Duplicate, Rights.ParameterCreate);
        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.ParameterEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.ParameterDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.dataSource = new AdvancedDataSource(null, this.paramsService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig);
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<Params>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Duplicate) {
            // Cas de duplication.
            this.itemDuplicated.emit(event.context);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer le paramètre '${event.context.name}'.`, event.context);
        }
    }
}
